module.exports = __webpack_public_path__ + "img/ai-stars.99654aa9.svg";